export const estadosBrasileiros = [
  { sigla: "AC", nome: "Acre" },
  { sigla: "AL", nome: "Alagoas" },
  { sigla: "AP", nome: "Amapá" },
  { sigla: "AM", nome: "Amazonas" },
  { sigla: "BA", nome: "Bahia" },
  { sigla: "CE", nome: "Ceará" },
  { sigla: "DF", nome: "Distrito Federal" },
  { sigla: "ES", nome: "Espírito Santo" },
  { sigla: "GO", nome: "Goiás" },
  { sigla: "MA", nome: "Maranhão" },
  { sigla: "MT", nome: "Mato Grosso" },
  { sigla: "MS", nome: "Mato Grosso do Sul" },
  { sigla: "MG", nome: "Minas Gerais" },
  { sigla: "PA", nome: "Pará" },
  { sigla: "PB", nome: "Paraíba" },
  { sigla: "PR", nome: "Paraná" },
  { sigla: "PE", nome: "Pernambuco" },
  { sigla: "PI", nome: "Piauí" },
  { sigla: "RJ", nome: "Rio de Janeiro" },
  { sigla: "RN", nome: "Rio Grande do Norte" },
  { sigla: "RS", nome: "Rio Grande do Sul" },
  { sigla: "RO", nome: "Rondônia" },
  { sigla: "RR", nome: "Roraima" },
  { sigla: "SC", nome: "Santa Catarina" },
  { sigla: "SP", nome: "São Paulo" },
  { sigla: "SE", nome: "Sergipe" },
  { sigla: "TO", nome: "Tocantins" },
];

export const tipoResponsavelTurma = [
  {id: 1, nome: 'Oferta Estadual'},
  {id: 2, nome: 'Oferta Externa'},
];

export const ambitoAtuacao = [
  {key: 1, name: 'Estadual'},
  {key: 2, name: 'Municipal'},
];

/*export const lotacaoEstadual = [
  { key: 1, ambito_id: 1, limite_funcoes: 2, name: 'CEAS'},
  { key: 2, ambito_id: 1, limite_funcoes: 1, name: 'CREAS Regional'},
  { key: 3, ambito_id: 1, limite_funcoes: 1, name: 'Diretoria Regional de Desenvolvimento Social'},
  { key: 4, ambito_id: 1, limite_funcoes: 1, name: 'Subsecretaria de Assistência Social'},
  { key: 5, ambito_id: 1, limite_funcoes: 1, name: 'Outros órgãos/instituições'},
];*/

export const lotacaoEstadual = [
  { nome: "CEAS" },
  { nome: "CREAS Regional" },
  { nome: "Diretoria Regional de Desenvolvimento Social" },
  { nome: "Subsecretaria de Assistência Social" },
  { nome: "Outros órgãos/instituições" },
];

export const funcaoDesenpenhada = [
  {nome: 'Prefeito(a)'},
  {nome: 'Vice-Prefeito(a)'},
  {nome: 'Deputado(a)'},
  {nome: 'Vereador(a)'},
  {nome: 'Assessor(a)'},
  {nome: 'Secretário(a)'},
  {nome: 'Secretário(a) Adjunto(a)'},
  {nome: 'Subsecretário(a)'},
  {nome: 'Gestor(a)'},
  {nome: 'Superintendente'},
  {nome: 'Diretor(a) / Coordenador(a) / Gerente'},
  {nome: 'Dirigente / Representante'},
  {nome: 'Profissional de Nível Superior'},
  {nome: 'Profissional de Nível Médio'},
  {nome: 'Profissional de Nível Fundamental'},
  {nome: 'Conselheiro(a) Tutelar'},
  {nome: 'Conselheiro(a)'},
  {nome: 'Secretário(a) Executivo(a) de Conselho'},
];

export const profissoes = [
  { nome: "Administrador"},
  { nome: "Advogado"},
  { nome: "Antropólogo"},
  { nome: "Assistente Social"},
  { nome: "Contador"},
  { nome: "Cuidador Social"},
  { nome: "Designer Gráfico / Web Designer"},
  { nome: "Economista"},
  { nome: "Economista Doméstico"},
  { nome: "Educador Social"},
  { nome: "Enfermeiro"},
  { nome: "Entrevistador / Cadastrador do CadÚnico"},
  { nome: "Estatístico"},
  { nome: "Gestor Público / Especialista em Políticas Públicas"},
  { nome: "Jornalista / Profissional de Comunicação"},
  { nome: "Musicoterapeuta"},
  { nome: "Nutricionista"},
  { nome: "Orientador Social"},
  { nome: "Pedagogo"},
  { nome: "Profissional de Tecnologia da Informação (TI)"},
  { nome: "Psicólogo"},
  { nome: "Sociólogo"},
  { nome: "Técnico / Assistente Administrativo"},
  { nome: "Técnico de Enfermagem"},
  { nome: "Terapeuta Ocupacional"},
  { nome: "Sem formação profissional/ocupação"},
  { nome: "Outra" },
];

export const areaRepresentadaGovernamental = [
  { nome: "Assistência Social" },
  { nome: "Saúde" },
  { nome: "Educação" },
  { nome: "Trabalho e Emprego" },
  { nome: "Fazenda" },
  { nome: "Habitação" },
  { nome: "Planejamento" },
  { nome: "Assessoria/Gabinete da Prefeitura" }, // Correção no nome
  { nome: "Outros" },
];

export const cargo = [
  { nome: "Titular" },
  { nome: "Suplente" },
  { nome: "Presidente" },
  { nome: "Vice-Presidente" },
];

export const areaRepresentadaSociedadeCivil = [
  { nome: "Usuário" },
  { nome: "Trabalhador" },
  { nome: "Entidade" },
];

export const areaAtuacaoEntidades = [
  { nome: "Atendimento" },
  { nome: "Assessoramento" },
  { nome: "Defesa e Garantia de Direitos" },
];

export const nivelProtecaoAtendimento = [
  { nome: "Proteção Social Básica" },
  { nome: "Proteção Social Especial de Média Complexidade" },
  { nome: "Proteção Social Especial de Alta Complexidade" },
];

export const oferta = [
  { nome: "Serviço" },
  { nome: "Programa" },
  { nome: "Projeto" },
  { nome: "Benefício Socioassistencial" },
];

export const orgaoAtuacaoMunicipal = [
  { nome: "Secretaria Municipal de Assistência Social" },
  { nome: "Conselho Municipal de Assistência Social" },
  { nome: "Entidades e Organizações de Assistência Social" },
  { nome: "Outras Secretarias/Órgãos da Prefeitura" },
];

export const areaAtuacaoSecretariaMunicipal = [
  { nome: "Proteção Social Básica" },
  { nome: "Proteção Social Especial" },
  { nome: "Gestão do SUAS" },
];

export const servicoProgramaProtecaoSocialBasica = [
  { nome: "Serviço de Proteção e Atendimento Integral a Famílias (PAIF)" },
  { nome: "Serviço de Convivência e Fortalecimento de Vínculos (SCFV)" },
  {
    nome: "Serviço de Proteção Social Básica no Domicílio para pessoas com deficiências e idosas",
  },
  { nome: "Gestão de Benefícios Socioassistenciais/CadÚnico" },
];

export const beneficio = [
  { nome: "Programa Bolsa Família e outra ação de transferência de renda" },
  { nome: "Benefício de Prestação Continuada (BPC)" },
  { nome: "Benefícios Eventuais" },
  { nome: "Outros" },
];

export const servicoProgramaProtecaoSocialEspecialMedia = [
  {
    nome: "Serviço de Proteção e Atendimento Especializado a Família e Indivíduos (PAEFI)",
  },
  { nome: "Serviço Especializado em Abordagem Social" },
  {
    nome: "Serviço de Proteção Social a adolescentes em cumprimento de medidas socioeducativas de Liberdade Assistida (LA) e Prestação de Serviços à Comunidade (PSC)",
  },
  {
    nome: "Serviço de Proteção Social Especial para Pessoas com Deficiência, Idosas e suas Famílias",
  },
  { nome: "Serviço Especializado para Pessoas em Situação de Rua" },
];

export const servicoProgramaProtecaoSocialEspecialAlta = [
  { nome: "Serviço de Acolhimento Institucional" },
  { nome: "Serviço de Acolhimento em República" },
  { nome: "Serviço de Acolhimento em Família Acolhedora" },
  {
    nome: "Serviço de Proteção em Situações de Calamidades Públicas e de Emergências",
  },
];

export const servicoProgramaGestaoSUAS = [
  { nome: "Vigilância Socioassistencial (Monitoramento)" },
  { nome: "Gestão do trabalho/Educação Permanente do SUAS" },
  { nome: "Regulação do SUAS" },
  { nome: "Gestão Financeira e Orçamentária do SUAS" },
  { nome: "Outros" },
];

export const superintendenciaAssessoria = [
  { nome: "Superintendência de Proteção Social Básica" },
  { nome: "Superintendência de Proteção Social Especial" },
  { nome: "Superintendência de Gestão do SUAS, Vigilância e Capacitação" },
  { nome: "Superintendência de Gestão do Fundo Estadual de Assistência Social", },
  { nome: "Gabinete" },
];

export const diretoriasSuperintendenciaProtecaoSocialBasica = [
  { nome: "Diretoria de Serviços e Benefícios Socioassistenciais" },
  { nome: "Diretoria de Gestão do CadÚnico e Programas Socioassistenciais" },
  { nome: "Não se aplica" },
];

export const diretoriasSuperintendenciaProtecaoSocialEspecial = [
  { nome: "Diretoria de Proteção Social de Média Complexidade" },
  { nome: "Diretoria de Proteção de Alta Complexidade" },
  { nome: "Não se aplica" },
];

export const diretoriasSuperintendenciaGestaoSUAS = [
  { nome: "Diretoria de Vigilância Socioassistencial" },
  { nome: "Diretoria de Educação Permanente do SUAS" },
  { nome: "Diretoria de Gestão e Regulação do SUAS" },
  { nome: "Não se aplica" },
];

export const diretoriasSuperintendenciaGestaoFundoEstadual = [
  {
    nome: "Diretoria de Gestão Orçamentária e Financeira do Fundo Estadual de Assistência Social",
  },
  { nome: "Diretoria de Gestão de Cofinanciamento do SUAS" },
  { nome: "Não se aplica" },
];

export const diretoriaRegionalDesenvolvimentoSocial = [
  { nome: "Almenara" },
  { nome: "Araçuaí" },
  { nome: "Curvelo" },
  { nome: "Diamantina" },
  { nome: "Divinópolis" },
  { nome: "Governador Valadares" },
  { nome: "Ituiutaba" },
  { nome: "Juiz de Fora" },
  { nome: "Metropolitana" },
  { nome: "Montes Claros" },
  { nome: "Muriaé" },
  { nome: "Paracatu" },
  { nome: "Passos" },
  { nome: "Patos de Minas" },
  { nome: "Poços de Caldas" },
  { nome: "Salinas" },
  { nome: "São João Del Rei" },
  { nome: "Teófilo Otoni" },
  { nome: "Timóteo" },
  { nome: "Uberaba" },
  { nome: "Uberlândia" },
  { nome: "Varginha" },
];

export const unidadeCreasRegional = [
  { nome: "Alto Jequitinhonha" },
  { nome: "Médio e Baixo Jequitinhonha" },
  { nome: "Mucuri" },
  { nome: "Vale do Rio Doce" },
];

export const orgaoOutrosPublicos = [
  { nome: "Direitos Humanos" },
  { nome: "Defesa Civil" },
  { nome: "Saúde" },
  { nome: "Educação" },
  { nome: "Esportes" },
  { nome: "Trabalho e Emprego" },
  { nome: "Outros" },
];

export const funcao = [
  { nome: "Profissional de Nível Superior" },
  { nome: "Profissional de Nível Médio" },
  { nome: "Gestor de Assistência Social" },
  { nome: "Coordenador" },
  { nome: "Assessor(a)" },
];

export const funcaoCREAS = [
  { nome: "Profissional de Nível Superior" },
  { nome: "Profissional de Nível Médio" },
  { nome: "Coordenador" },
];

export const funcaoConcelho = [
  { nome: "Conselheiro" },
  { nome: "Secretaria Executiva" },
];

export const vinculo = [
  { key: 1, outros: false, nome: "Comissionado" },
  { key: 2, outros: false, nome: "Contratado" },
  { key: 3, outros: false, nome: "Efetivo" },
  { key: 4, outros: false, nome: "Estagiário" },
  { key: 5, outros: false, nome: "Temporário" },
  { key: 6, outros: true, nome: "Outros" },
];

/* lista de áreas de atuação para utilizar no multselect */
export const areaAtuacao = [
  {group: 'Assistência Social (SUAS)', name: 'Proteção Social Básica'},
  {group: 'Assistência Social (SUAS)', name: 'Proteção Social Especial de Média Complexidade'},
  {group: 'Assistência Social (SUAS)', name: 'Proteção Social Especial de Alta Complexidade'},
  {group: 'Assistência Social (SUAS)', name: 'Gestão do SUAS - Vigilância Socioassistencial'},
  {group: 'Assistência Social (SUAS)', name: 'Gestão do SUAS - Gestão do Trabalho e Educação Permanente'},
  {group: 'Assistência Social (SUAS)', name: 'Gestão do SUAS - Gestão e Regulação do SUAS'},
  {group: 'Assistência Social (SUAS)', name: 'Gestão do SUAS - Gestão Financeira e Orçamentária'},
  {group: 'Assistência Social (SUAS)', name: 'Gestão do SUAS - Cadastro Único, Programas (ex: PBF, BPC) e benefícios'},
  {group: 'Assistência Social (SUAS)', name: 'Gestão do SUAS - Temas gerais (Secretários, Subsecretários, Assessores, etc.)'},
  {group: 'Assistência Social (SUAS)', name: 'Controle Social - Trabalhadores (as)'},
  {group: 'Assistência Social (SUAS)', name: 'Controle Social - Usuários (as)'},
  {group: 'Assistência Social (SUAS)', name: 'Controle Social - Entidades'},
  {group: 'Assistência Social (SUAS)', name: 'Controle Social - Governo'},
  {group: 'Outras Políticas Públicas', name: 'Saúde'},
  {group: 'Outras Políticas Públicas', name: 'Educação'},
  {group: 'Outras Políticas Públicas', name: 'Direitos Humanos e Cidadania'},
  {group: 'Outras Políticas Públicas', name: 'Segurança Alimentar e Nutricional'},
  {group: 'Outras Políticas Públicas', name: 'Esporte e Lazer'},
  {group: 'Outras Políticas Públicas', name: 'Defesa Civil'},
  {group: 'Outras Políticas Públicas', name: 'Segurança Pública'},
  {group: 'Outras Políticas Públicas', name: 'Política de direitos das mulheres'},
  {group: 'Outras Políticas Públicas', name: 'Inclusão produtiva, Trabalho, Emprego e Renda'},
  {group: 'Outras Políticas Públicas', name: 'Fazenda e Finanças públicas'},
  {group: 'Outras Políticas Públicas', name: 'Habitação e Desenvolvimento Urbano'},
  {group: 'Outras Políticas Públicas', name: 'Planejamento e Gestão governamental'},
  {group: 'Outros', name: 'Ministério Público'},
  {group: 'Outros', name: 'Defensoria Pública'},
  {group: 'Outros', name: 'Judiciário'},
  {group: 'Outros', name: 'Legislativo'},
  {group: 'Outros', name: 'Conselho Tutelar'},
  {group: 'Outros', name: 'Conselhos de Direitos (Criança e Adolescente, Idoso, Pessoa com Deficiência, etc.)'},
  {group: 'Outros', name: 'Delegacias Especializadas (Mulher, Criança e Adolescente, Idoso)'},
  {group: 'Outros', name: 'Ordem dos Advogados do Brasil (OAB)'},
  {group: 'Outros', name: 'Ouvidorias Públicas'},
  {group: 'Outros', name: 'Tribunal de Contas'},
];

export const instituicao = [
  {nome: 'Saúde'},
  {nome: 'Educação'},
  {nome: 'Direitos Humanos e Cidadania'},
  {nome: 'Segurança Alimentar e Nutricional'},
  {nome: 'Esporte e Lazer'},
  {nome: 'Defesa Civil'},
  {nome: 'Segurança Pública'},
  {nome: 'Política de direitos das mulheres'},
  {nome: 'Inclusão produtiva, Trabalho, Emprego e Renda'},
  {nome: 'Fazenda e Finanças públicas'},
  {nome: 'Habitação e Desenvolvimento Urbano'},
  {nome: 'Planejamento e Gestão governamental'},
  {nome: 'Ministério Público'},
  {nome: 'Defensoria Pública'},
  {nome: 'Judiciário'},
  {nome: 'Legislativo'},
  {nome: 'Conselho Tutelar'},
  {nome: 'Conselhos de Direitos (Criança e Adolescente, Idoso, Pessoa com Deficiência, etc.)'},
  {nome: 'Delegacias Especializadas (Mulher, Criança e Adolescente, Idoso)'},
  {nome: 'Ordem dos Advogados do Brasil (OAB)'},
  {nome: 'Ouvidorias Públicas'},
  {nome: 'Outro'},
];